/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_OutInputs */



/**
* | output |
* | --- |
* | "OUT" |
*
* @param {Ccsl_Export_Header_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_out = /** @type {((inputs?: Ccsl_Export_Header_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OUT")
	if (locale === "de") return /** @type {LocalizedString} */ ("AUS")
	if (locale === "it") return /** @type {LocalizedString} */ ("FUORI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ВНЕ")
	if (locale === "es") return /** @type {LocalizedString} */ ("AFUERA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出去")
	if (locale === "ja") return /** @type {LocalizedString} */ ("外")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाहर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("FORA")
	return /** @type {LocalizedString} */ ("OUT")
});